import React, { useState, useContext } from 'react';
import RecipesContext from "context/RecipeContext";
import "../Sidebar.css";

const Row = ({
    category,
    row,
    handleSelection,
}) => {
    const { tagsSelected } = useContext(RecipesContext.context);


    const [active, setActive] = useState(false);

    const handleSelectTags = (name,condition, id) => {
        handleSelection(name, condition, id)
    }

    return ( 
        <div className="react-StackOptionsContainer">
            <div 
                className={
                    tagsSelected[category]?.find(category => category.name === row.name) ?
                    "react-StackOptionActive"
                    : 
                    "react-StackOption"
                }
                onClick={() => { 
                    setActive(!active);
                    let condition = (tagsSelected[category]?.find(category => category.name === row.name)) ? "remove" : "add"
                    handleSelectTags(row.name, condition, row.id);
                }}
            >
                {row.name}
            </div>
        </div>
    );
} 
 
export default Row;